/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  defaultDateFormat: 'DD-MM-YYYY',
  // api_url:'http://127.0.0.1:8001',
  
  api_url:'https://backend.atharplatform.com',
  api_img:'https://backend.atharplatform.com',
  // api_url:'http://127.0.0.1:8001',
  // api_img:'http://127.0.0.1:8001',
  defaultLanguage: 'ar',
  defaultPageSize:20
};
